import SalesSubnavView from './sales-navigation-view';

export default SalesSubnavView;
